import { useCallback, useEffect, useState } from 'react'
import { getEventCommentsCount } from '../services/WorkflowService'
import {
  EVENT_COMMENTS_UPDATED,
  subscribeSidebarUrlChange
} from '../utils/sidebarUrl'

export const useEventCommentsCount = (eventId: number, enabled = true) => {
  const [count, setCount] = useState(0)

  const fetchCount = useCallback(async () => {
    if (!eventId || !enabled) {
      setCount(0)
      return
    }
    try {
      const result = await getEventCommentsCount(eventId)
      const value = result.data?.eventCommentsCount
      setCount(typeof value === 'number' ? value : 0)
    } catch (err) {
      console.error('Error getting event comments count:', err)
      setCount(0)
    }
  }, [eventId, enabled])

  useEffect(() => {
    fetchCount()
  }, [fetchCount])

  useEffect(() => {
    if (!enabled || !eventId) return

    const onUpdated = (event: Event) => {
      const custom = event as CustomEvent<{ eventId: number }>
      if (custom.detail?.eventId === eventId) {
        fetchCount()
      }
    }

    window.addEventListener(EVENT_COMMENTS_UPDATED, onUpdated)
    const unsubscribe = subscribeSidebarUrlChange(fetchCount)
    return () => {
      window.removeEventListener(EVENT_COMMENTS_UPDATED, onUpdated)
      unsubscribe()
    }
  }, [enabled, eventId, fetchCount])

  return { count, fetchCount }
}
